export default function anonymous(props
/*``*/) {
var out='<div class="'+(props.styles.tooltipContainer)+'"></div>';return out;
}


//////////////////
// WEBPACK FOOTER
// ./default-modules/ui/core/tooltip/templates/tooltipContainer.dot
// module id = 197
// module chunks = 0 1 2 3 4